
/** 混入方法 ::: 
 *  @mixins mixFormConfig 表单项属性解构混入
 */
import { mixFormConfig } from "@/mixins/common/mix_form_config.js";
/** 工具方法 :::
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { makeComputedGroup } from "@/utils/computed_utils.js";


/** @name FormItemTemplate.vue 混入
 *  @author 王汝鹏
 *  @version 2019-11-28
 */
export const mixFormItemTemplate = {
  mixins: [ mixFormConfig ],
  inject: [
    'form_item_template_store',
    'form_item_template_event_config_manager',
    'form_item_template_form_node_manager',
    'form_item_template_form_list_manager'
  ],
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Object} activeNode 激活表单项
     *  @return {Object} formMap 表单项字典
     */
    ...makeComputedGroup("form_item_template_store", {
      activeNode: { get:"activeNode" },
      formMap: { get:"formMap" }
    }),
    /** 管理者说明 ::: 
     *  @return {Function} eventConfigManager 事件配置管理者
     *  @return {Function} formNodeManager 表单节点管理者
     *  @return {Function} formListManager 表单列表管理者
     */
    eventConfigManager() { return this.form_item_template_event_config_manager; },
    formNodeManager() { return this.form_item_template_form_node_manager; },
    formListManager() { return this.form_item_template_form_list_manager; }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/form_item/mix_form_item_template.js